import { ref, snapshot } from 'valtio';
import { calcDateRange } from '../../app/store-actions/top-bar-store-actions';
import TopBarStore from '../../app/stores/top-bar-store';
import { getAppOwnersStore } from '../../application-owners/api/applications-owners-api';
import { createGraphInfo } from '../../common/issues-trends/issues-trends-utils';
import InventoryFiltersStore from '../../dashboard-inventory/stores/inventory-filters-store';
import ScanStore from '../../new-scan/store/scan-store';
import executiveService from '../services';
import ExecutiveStore from '../stores/executive-store';

export const fetchIssuesScore = async () => {
  const { filters } = snapshot(InventoryFiltersStore);
  const { displaySelectedAppOwners } = getAppOwnersStore();
  const { dateRange } = snapshot(TopBarStore);
  const { isScanning } = snapshot(ScanStore);
  const [from, to] = calcDateRange(dateRange);
  const { scanID, realScanId } = snapshot(ScanStore);
  const response = await executiveService.getIssuesScore.execute(
    {
      limit: 5,
      filters,
      ...(realScanId ? { scanId: realScanId } : scanID && { scanId: scanID }),
      owners: displaySelectedAppOwners,
      dateRange: { from, to },
    },
    !isScanning,
  );
  if (response) {
    ExecutiveStore.issuesScore = ref(createGraphInfo(response));
  }
};
